import styled from 'styled-components';

export type NewBadgeProps = {
  size?: 'small' | 'medium';
};

export const NewBadge = ({ size = 'small' }: NewBadgeProps) => (
  <Badge size={size}>NEW</Badge>
);

const Badge = styled.span<{ size: 'small' | 'medium' }>`
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  font-size: ${({ size }) => (size === 'small' ? '0.6rem' : '0.7rem')};
  font-weight: bold;
  padding: ${({ size }) => (size === 'small' ? '0.2rem 0.4rem' : '0.3rem 0.5rem')};
  border-radius: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: absolute;
  top: ${({ size }) => (size === 'small' ? '-0.3rem' : '-0.4rem')};
  right: ${({ size }) => (size === 'small' ? '0.2rem' : '0.1rem')};
  z-index: 1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 850px) {
    right: ${({ size }) => (size === 'small' ? '0.5rem' : '0.4rem')};
  }
`;